<template>
  <div class="presupuesto-interno-vendedor-comision">
    <b-card no-header>
      <form>
        <b-form-radio 
          v-model="isComisionInterna" 
          name="opcionComisionInterna" 
          :value="Boolean(true)">Comisión Interna (Comercial)</b-form-radio>

        <div class="parametros-comision">
          <b-form-group
            label="Pje. Comisión"
            label-for="pjeComisionInterna"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="pjeComisionInterna"
              v-model.trim="$v.pjeComisionInterna.$model" 
              :state="pjeComisionInternaValida"
              type="number"
              :readonly="!isComisionInterna">
            </b-form-input>
            <b-form-invalid-feedback id="pjeComisionInternaFeedback">
              {{ pjeComisionInternaInvalidaMsj }}
            </b-form-invalid-feedback>
          </b-form-group>
        </div>  

        <b-form-radio 
          v-model="isComisionInterna" 
          name="opcionComisionInterna" 
          :value="Boolean(false)">Comisión de Vendedor</b-form-radio>

        <div class="parametros-comision">
          <b-form-group
            label="Vendedor"
            label-for="vendedor"
            :label-cols="labelCols"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarVendedor">
                <b-input-group-text v-if="!isComisionInterna"> 
                  <i :class="{ 'fa fa-search': !vendedor,
                                'fa fa-remove': vendedor  }"></i>
                  <!-- <i class="fa fa-search"></i> -->
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="vendedor"
                :value="vendedorNombre"
                :state="vendedorValido"
                readonly
                type="text"/>
              <b-form-invalid-feedback id="vendedorFeedback">
                {{ vendedorInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          
          <div class="tipo-comision">
            <label>Tipo de Comisión</label> 

            <b-form-radio 
              v-model="tipoComisionPorcentaje" 
              name="opcionTipoComision" 
              :value="Boolean(true)"
              :disabled="isComisionInterna"
              stacked>Porcentaje</b-form-radio>
    
            <b-form-radio 
              v-model="tipoComisionImporte" 
              name="opcionTipoComision" 
              :value="Boolean(true)"
              :disabled="isComisionInterna"
              stacked>Importe</b-form-radio>
    
            <b-form-radio 
              v-model="tipoComisionPorcentajeImporte" 
              name="opcionTipoComision" 
              :value="Boolean(true)"
              :disabled="isComisionInterna"
              stacked>Porcentaje + Importe</b-form-radio>
          </div> 
          
          <div class="parametros-vendedor">
            <label>Tipo de Porcentaje</label> 

            <b-form-radio 
              v-model="tipoPorcentajeFijo" 
              name="opcionTipoPorcentaje" 
              :value="Boolean(true)"
              :disabled="isComisionInterna || tipoComisionImporte"
              stacked>Porcentaje fijo</b-form-radio>

            <b-form-group 
              description="Pje de comisión">
              <b-form-input 
                id="pjeComisionPresupuesto"
                v-model.trim="$v.pjeComisionPresupuesto.$model" 
                :state="pjeComisionPresupuestoValido"
                type="number"
                :readonly="tipoComisionImporte || tipoPjeComision == 2 || isComisionInterna">
              </b-form-input>
              <b-form-invalid-feedback id="pjeComisionPresupuestoFeedback">
                {{ pjeComisionPresupuestoInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>
              
            <!-- <b-form-group 
              description="Pje de comisión">
              <b-form-input 
                id="pjeComisionVendedor"
                v-model.trim="$v.pjeComisionVendedor.$model" 
                :state="pjeComisionVendedorValido"
                type="number"
                :readonly="tipoComisionImporte || tipoPjeComision == 2 || isComisionInterna">
              </b-form-input>
              <b-form-invalid-feedback id="pjeComisionVendedorFeedback">
                {{ pjeComisionVendedorInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group> -->
      
            <b-form-radio 
              v-model="tipoPorcentajeFee" 
              name="opcionTipoPorcentaje" 
              :value="Boolean(true)"
              :disabled="isComisionInterna || tipoComisionImporte"
              stacked>Porcentaje del Fee</b-form-radio>

            <b-form-group 
              description="Pje del Fee como Comisión">
              <b-form-input 
                id="pjeFeeComisionPresupuesto"
                v-model.trim="$v.pjeFeeComisionPresupuesto.$model" 
                :state="pjeFeeComisionPresupuestoValido"
                type="number"
                :readonly="tipoComisionImporte || tipoPjeComision == 1 || isComisionInterna">
              </b-form-input>
              <b-form-invalid-feedback id="pjeFeeComisionPresupuestoFeedback">
                {{ pjeFeeComisionPresupuestoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
              
            <!-- <b-form-group 
              description="Pje del Fee como Comisión">
              <b-form-input 
                id="pjeFeeComisionVendedor"
                v-model.trim="$v.pjeFeeComisionVendedor.$model" 
                :state="pjeFeeComisionVendedorValido"
                type="number"
                :readonly="tipoComisionImporte || tipoPjeComision == 1 || isComisionInterna">
              </b-form-input>
              <b-form-invalid-feedback id="pjeFeeComisionVendedorFeedback">
                {{ pjeFeeComisionVendedorInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group> -->
    
            <label>Importe de la Comisión</label> 

            <b-form-group>
              <b-form-input 
                id="importePresupuesto"
                v-model.trim="$v.importePresupuesto.$model" 
                :state="importePresupuestoValido"
                type="number"
                :readonly="tipoComisionPorcentaje || isComisionInterna">
              </b-form-input>
              <b-form-invalid-feedback id="importePresupuestoFeedback">
                {{ importePresupuestoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group>
              <b-form-input 
                id="importeVendedor"
                v-model.trim="$v.importeVendedor.$model" 
                :state="importeVendedorValido"
                type="number"
                :readonly="tipoComisionPorcentaje || isComisionInterna">
              </b-form-input>
              <b-form-invalid-feedback id="importeVendedorFeedback">
                {{ importeVendedorInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group> -->
          </div>
        </div>          

        <hr>

        <b-form-group
          label="Cotización"
          label-for="montoCotizacion"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="montoCotizacion"
            :value="montoBaseComision | moneda(monedaSimbolo)" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          v-if="tipoComision == 1 || tipoComision == 3"
          label="Pje.Comisión"
          label-for="pjeComision"
          :labelCols="labelCols"
          horizontal>
          <b-input-group>
            <b-form-input 
              id="pjeComision"
              :value="pjeComision | numero(2, true)" 
              readonly>
            </b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group
          v-if="tipoComision == 2 || tipoComision == 3"
          label="Importe"
          label-for="importe"
          :labelCols="labelCols"
          horizontal>
          <b-input-group>
            <b-form-input 
              id="importe"
              :value="importe | moneda(monedaSimbolo)" 
              readonly>
            </b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label="Comisión"
          label-for="montoComision"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="montoComision"
            :value="montoComision | moneda(monedaSimbolo)" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <b-modal ref="searchVendedorModal" 
        title="Seleccionar Vendedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-vendedor
        @vendedorSeleccionado="vendedorSeleccionado">
      </app-search-vendedor>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchVendedor from '../vendedores/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { decimal, minValue, maxValue } from 'vuelidate/lib/validators';
import helpers from '../../mixins/helpers';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'PresupuestoInternoVendedorComision',
  components: {
    appSearchVendedor: SearchVendedor,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
      vendedorComision: {
        type: Object,
        required: false,
        default: null
      },
      montoBaseComision: {
        type: Number,
        required: true,
      },
      pjeComisionInternaComercial: {
        type: Number,
        required: true,
      },
      monedaId: {
        type: Number,
        required: true,
      },
  },
  data: () => {
    return {
      vendedorComisionId: null,
      isComisionInterna: false,
      vendedor: null,
      tipoComision: 1,
      tipoPjeComision: 1,
      pjeComisionVendedor: 0,
      pjeFeeComisionVendedor: 0,
      importeVendedor: 0,
      pjeComisionPresupuesto: 0,
      pjeFeeComisionPresupuesto: 0,
      importePresupuesto: 0,
      pjeComisionInterna: 0,
      pjeComision: 0,
      importe: 0,

      vendedorValido: null,
      vendedorInvalidoMsj: '',
      // pjeComisionVendedorValido: null,
      // pjeComisionVendedorInvalidoMsj: '',
      // pjeFeeComisionVendedorValido: null,
      // pjeFeeComisionVendedorInvalidoMsj: '',
      // importeVendedorValido: null,
      // importeVendedorInvalidoMsj: '',
      pjeComisionPresupuestoValido: null,
      pjeComisionPresupuestoInvalidoMsj: '',
      pjeFeeComisionPresupuestoValido: null,
      pjeFeeComisionPresupuestoInvalidoMsj: '',
      importePresupuestoValido: null,
      importePresupuestoInvalidoMsj: '',
      pjeComisionInternaValida: null,
      pjeComisionInternaInvalidaMsj: '',

      labelCols: 2
    }
  },
  created() {
    if (this.vendedorComision) {
      this.vendedorComisionId = this.vendedorComision.id;
      this.vendedor = this.vendedorComision.vendedor;
      this.tipoComision = this.vendedorComision.tipoComision;
      this.tipoPjeComision = this.vendedorComision.tipoPjeComision;
      this.pjeComisionVendedor = this.vendedorComision.pjeComisionVendedor;
      this.pjeFeeComisionVendedor = this.vendedorComision.pjeFeeComisionVendedor;
      this.importeVendedor = this.vendedorComision.importeVendedor;
      this.pjeComisionPresupuesto = this.vendedorComision.pjeComisionPresupuesto;
      this.pjeFeeComisionPresupuesto = this.vendedorComision.pjeFeeComisionPresupuesto;
      this.importePresupuesto = this.vendedorComision.importePresupuesto;
      this.pjeComision = this.vendedorComision.pjeComision;
      this.importe = this.vendedorComision.importe;
      // this.isComisionInterna = this.vendedorComision.vendedor != null ? false : true;
      this.isComisionInterna = this.vendedorComision.comisionInterna;
    } else {
      this.vendedorComisionId = helpers.methods.getUUID();
    }

    this.pjeComisionInterna = this.pjeComisionInternaComercial;
  },
  computed: {
    ...mapFields([
      'feeAgencia',
      'vendedoresComisiones'
    ]),    
    vendedorNombre() {
      if (this.vendedor) {
        if (this.vendedor.nombre) {
          return this.vendedor.nombre.trim();
        }
      }
      return null;
    },
    monedaSimbolo() {
      if (this.monedaId) {
        if (this.monedaId == 102) {  
          return 'usd';
        }
      }
      return '$';
    },
    montoComision() {
      switch (this.tipoComision) {
        case 1: /* Porcentaje */
          return parseFloat(this.montoBaseComision) * parseFloat(this.pjeComision) / 100;

        case 2: /* Importe */
          return this.importe;

        case 3: /* Porcentaje + Importe */
          return parseFloat(this.montoBaseComision) * parseFloat(this.pjeComision) / 100
            + parseFloat(this.importe);
      }
    },
    tipoComisionPorcentaje: {
      get() {
        return this.tipoComision == 1;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 1;
          
          if (this.isComisionInterna) {
            this.pjeComision = this.pjeComisionInterna;
          } else {
            switch (this.tipoPjeComision) {
              case 1: /* Porcentaje Fijo */
                this.pjeComision = parseFloat(this.pjeComisionPresupuesto);
                break;
            
              case 2: /* Porcentaje del Fee */
                this.pjeComision = this.feeAgencia * this.pjeFeeComisionPresupuesto / 100;
                break;
            }
          }
          this.importe = 0;
        }
      }
    },
    tipoComisionImporte: {
      get() {
        return this.tipoComision == 2;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 2;
          this.pjeComision = 0;
          this.importe = this.importePresupuesto;
        }
      }
    },
    tipoComisionPorcentajeImporte: {
      get() {
        return this.tipoComision == 3;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 3;

          if (this.isComisionInterna) {
            this.pjeComision = this.pjeComisionInterna;
          } else {
            switch (this.tipoPjeComision) {
              case 1: /* Porcentaje Fijo */
                this.pjeComision = parseFloat(this.pjeComisionPresupuesto);
                break;
            
              case 2: /* Porcentaje del Fee */
                this.pjeComision = this.feeAgencia * this.pjeFeeComisionPresupuesto / 100;
                break;
            }
          }
          this.importe = this.importePresupuesto;
        }
      }
    },
    tipoPorcentajeFijo: {
      get() {
        return this.tipoPjeComision == 1;
      },
      set(newVal) {
        if (newVal) {
          this.tipoPjeComision = 1;
        }
      }
    },
    tipoPorcentajeFee: {
      get() {
        return this.tipoPjeComision == 2;
      },
      set(newVal) {
        if (newVal) {
          this.tipoPjeComision = 2;
        }
      }
    },
  },
  methods: {
    save() {
      /* Validamos si existe una comisión definida para el vendedor */
      if (Array.isArray(this.vendedoresComisiones) && this.vendedoresComisiones.length > 0) {
        if (this.vendedoresComisiones.some(vc => vc.vendedorId == (this.vendedor ? this.vendedor.id : 0)
            && vc.id != this.vendedorComisionId)) {
          if (this.vendedor && this.vendedor.id) {
            this.showErrorMsj(new Error(`Ya existe una comisión definida para el vendedor seleccionado`));
          } else {
            this.showErrorMsj(new Error('Ya existe una comisión interna definida'));
          }
          return;
        }
      }

      let save = true;

      this.$v.$touch();

      if (this.$v.pjeComisionPresupuesto.$error) {
        this.pjeComisionPresupuestoValido = false;
        if (!this.$v.pjeComisionPresupuesto.decimal) {
          this.pjeComisionPresupuestoInvalidoMsj = 'El porcentaje de comisión debe ser un valor numérico';
        } else {
          if (!this.$v.pjeComisionPresupuesto.maxValue || !this.$v.pjeComisionPresupuesto.minValue) {
            this.pjeComisionPresupuestoInvalidoMsj = 'El porcentaje de comisión ingresado no es válido';
          }      
        }     
      } else {
        this.pjeComisionPresupuestoValido = null;
        this.pjeComisionPresupuestoInvalidoMsj = '';
      }

      if (this.$v.pjeFeeComisionPresupuesto.$error) {
        this.pjeFeeComisionPresupuestoValido = false;
        if (!this.$v.pjeFeeComisionPresupuesto.decimal) {
          this.pjeFeeComisionPresupuestoInvalidoMsj = 'El porcentaje de comisión debe ser un valor numérico';
        } else {
          if (!this.$v.pjeFeeComisionPresupuesto.maxValue || !this.$v.pjeFeeComisionPresupuesto.minValue) {
            this.pjeFeeComisionPresupuestoInvalidoMsj = 'El porcentaje de comisión ingresado no es válido';
          }      
        }     
      } else {
        this.pjeFeeComisionPresupuestoValido = null;
        this.pjeFeeComisionPresupuestoInvalidoMsj = '';
      }

      if (this.$v.importePresupuesto.$error) {
        this.importePresupuestoValido = false;
        if (!this.$v.importePresupuesto.decimal) {
          this.importePresupuestoInvalidoMsj = 'El importe debe ser un valor numérico';
        } else {
          if (!this.$v.importePresupuesto.minValue) {
            this.importePresupuestoInvalidoMsj = 'El importe ingresado no es válido';
          }      
        }     
      } else {
        this.importePresupuestoValido = null;
        this.importePresupuestoInvalidoMsj = '';
      }

      // if (this.$v.pjeComisionVendedor.$error) {
      //   this.pjeComisionVendedorValido = false;
      //   if (!this.$v.pjeComisionVendedor.decimal) {
      //     this.pjeComisionVendedorInvalidoMsj = 'El porcentaje de comisión debe ser un valor numérico';
      //   } else {
      //     if (!this.$v.pjeComisionVendedor.maxValue || !this.$v.pjeComisionVendedor.minValue) {
      //       this.pjeComisionVendedorInvalidoMsj = 'El porcentaje de comisión ingresado no es válido';
      //     }      
      //   }     
      // } else {
      //   this.pjeComisionVendedorValido = null;
      //   this.pjeComisionVendedorInvalidoMsj = '';
      // }

      // if (this.$v.pjeFeeComisionVendedor.$error) {
      //   this.pjeFeeComisionVendedorValido = false;
      //   if (!this.$v.pjeFeeComisionVendedor.decimal) {
      //     this.pjeFeeComisionVendedorInvalidoMsj = 'El porcentaje de comisión debe ser un valor numérico';
      //   } else {
      //     if (!this.$v.pjeFeeComisionVendedor.maxValue || !this.$v.pjeFeeComisionVendedor.minValue) {
      //       this.pjeFeeComisionVendedorInvalidoMsj = 'El porcentaje de comisión ingresado no es válido';
      //     }      
      //   }     
      // } else {
      //   this.pjeFeeComisionVendedorValido = null;
      //   this.pjeFeeComisionVendedorInvalidoMsj = '';
      // }

      // if (this.$v.importeVendedor.$error) {
      //   this.importeVendedorValido = false;
      //   if (!this.$v.importeVendedor.decimal) {
      //     this.importeVendedorInvalidoMsj = 'El importe debe ser un valor numérico';
      //   } else {
      //     if (!this.$v.importeVendedor.minValue) {
      //       this.importeVendedorInvalidoMsj = 'El importe ingresado no es válido';
      //     }      
      //   }     
      // } else {
      //   this.importeVendedorValido = null;
      //   this.importeVendedorInvalidoMsj = '';
      // }

      if (this.$v.pjeComisionInterna.$error) {
        this.pjeComisionInternaValida = false;
        if (!this.$v.pjeComisionInterna.decimal) {
          this.pjeComisionInternaInvalidaMsj = 'El porcentaje de comisión debe ser un valor numérico';
        } else {
          if (!this.$v.pjeComisionInterna.maxValue || !this.$v.pjeComisionInterna.minValue) {
            this.pjeComisionInternaInvalidaMsj = 'El porcentaje de comisión ingresado no es válido';
          }      
        }     
      } else {
        this.pjeComisionInternaValida = null;
        this.pjeComisionInternaInvalidaMsj = '';
      }

      if (!this.$v.$anyError) {
        if (save) {
          let vendedorId = 0;
          let vendedor = null;
          let tipoComision = 0;
          let tipoPjeComision = 0;
          let pjeComisionVendedor = 0;
          let pjeFeeComisionVendedor = 0;
          let importeVendedor = 0;
          let pjeComisionPresupuesto = 0;
          let pjeFeeComisionPresupuesto = 0;
          let importePresupuesto = 0;

          if (this.isComisionInterna) {
            vendedorId = 0;
            vendedor = null;
            tipoComision = 1;
            tipoPjeComision = 1;
            pjeComisionVendedor = this.pjeComisionInterna;
            pjeFeeComisionVendedor = 0;
            importeVendedor = 0;
            pjeComisionPresupuesto = this.pjeComisionInterna;
            pjeFeeComisionPresupuesto = 0;
            importePresupuesto = 0;
          } else {
            vendedorId = this.vendedor? this.vendedor.id || 0 : 0;
            vendedor = this.vendedor || null;
            tipoComision = this.tipoComision;
            tipoPjeComision = this.tipoPjeComision;
            pjeComisionVendedor = this.pjeComisionVendedor;
            pjeFeeComisionVendedor = this.pjeFeeComisionVendedor;
            importeVendedor = this.importeVendedor;
            pjeComisionPresupuesto = this.pjeComisionPresupuesto;
            pjeFeeComisionPresupuesto = this.pjeFeeComisionPresupuesto;
            importePresupuesto = this.importePresupuesto;
            //importePresupuesto = this.tipoComision == 2 || this.tipoComision == 3 ? this.importePresupuesto : 0;
          }

          if (this.isComisionInterna || vendedorId != 0)
          {
              const vendedorComision = {
                id: this.vendedorComisionId,
                vendedorId: vendedorId,
                vendedor: vendedor,
                comisionInterna: this.isComisionInterna,
                tipoComision,
                tipoPjeComision,
                pjeComisionVendedor,
                pjeFeeComisionVendedor,
                importeVendedor,
                pjeComisionPresupuesto,
                pjeFeeComisionPresupuesto,
                importePresupuesto
              }
    
              this.$store.dispatch('presupuestointerno/setVendedorComision', vendedorComision)
                .then(() => this.$emit('close'))
                .catch(error => this.showErrorMsj(error));
          }
        }
      }
    },
    cancelar() {
      this.$emit('close')
    },
    seleccionarVendedor() {
      if (this.vendedor) {
        this.vendedor = null;
        this.pjeComisionVendedor = 0;
        this.pjeFeeComisionVendedor = 0;
        this.importeVendedor = 0;
        this.pjeComisionPresupuesto = 0;
        this.pjeFeeComisionPresupuesto = 0;
        this.importePresupuesto = 0;
        this.pjeComision = 0;
        this.importe = 0;
      } else {
        this.$refs.searchVendedorModal.show()
      }
    },
    vendedorSeleccionado(item) {
      this.$refs.searchVendedorModal.hide();
      this.vendedor = item;
      this.tipoComision = item.tipoComision;
      this.tipoPjeComision = item.tipoPjeComision;
      this.pjeComisionVendedor = item.pjeComision;
      this.pjeFeeComisionVendedor = item.pjeFeeComision;
      this.importeVendedor = item.importeComision;
      this.pjeComisionPresupuesto = item.pjeComision;
      this.pjeFeeComisionPresupuesto = item.pjeFeeComision;
      this.importePresupuesto = item.importeComision;

      switch (this.tipoComision) {
        case 1: /* Porcentaje */
          switch (this.tipoPjeComision) {
            case 1: /* Porcentaje Fijo */
              this.pjeComision = parseFloat(item.pjeComision);
              break;
          
            case 2: /* Porcentaje del Fee */
              this.pjeComision = this.feeAgencia * item.pjeFeeComision / 100;
              break;
          }
          this.importe = 0;
          break;

        case 2: /* Importe */
          this.pjeComision = 0;
          this.importe = this.importePresupuesto;
          break;
          
        case 3: /* Porcentaje + Importe */
          switch (this.tipoPjeComision) {
            case 1: /* Porcentaje Fijo */
              this.pjeComision = parseFloat(item.pjeComision);
              break;
          
            case 2: /* Porcentaje del Fee */
              this.pjeComision = this.feeAgencia * item.pjeFeeComision / 100;
              break;
          }
          this.importe = this.importePresupuesto;
          break;
      }
    },
  },
  validations: {
    pjeComisionPresupuesto: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    pjeFeeComisionPresupuesto: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    pjeComisionInterna: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    importePresupuesto: {
      decimal,
      minValue: minValue(0)
    },
  },  
  watch: {
    'isComisionInterna' : function(newVal, oldVal) {
      if ((/true/i).test(this.isComisionInterna)) {
        this.tipoComision = 1;
        this.tipoPjeComision = 1;
        this.pjeComision = this.pjeComisionInterna;
        this.importe = 0;
      } else {
        switch (this.tipoComision) {
          case 1: /* Porcentaje */
            switch (this.tipoPjeComision) {
              case 1: /* Porcentaje Fijo */
                this.pjeComision = parseFloat(this.pjeComisionPresupuesto);
                break;
            
              case 2: /* Porcentaje del Fee */
                this.pjeComision = this.feeAgencia * this.pjeFeeComisionPresupuesto / 100;
                break;
            }
            this.importe = 0;
            break;

          case 2: /* Importe */
            this.pjeComision = 0;
            this.importe = this.importePresupuesto;
            break;

          case 3: /* Porcentaje + Importe */
            switch (this.tipoPjeComision) {
              case 1: /* Porcentaje Fijo */
                this.pjeComision = parseFloat(this.pjeComisionPresupuesto);
                break;
            
              case 2: /* Porcentaje del Fee */
                this.pjeComision = this.feeAgencia * this.pjeFeeComisionPresupuesto / 100;
                break;
            }
            this.importe = this.importePresupuesto;
            break;
        }
      }
    },
    'pjeComisionInterna' : function(newVal, oldVal) {
      this.pjeComision = this.pjeComisionInterna;
    },
    'pjeComisionPresupuesto' : function(newVal, oldVal) {
      if ((this.tipoComision == 1 || this.tipoComision == 3) && this.tipoPjeComision == 1) {
        this.pjeComision = parseFloat(this.pjeComisionPresupuesto);
        //this.importe = 0;
      }
    },
    'pjeFeeComisionPresupuesto' : function(newVal, oldVal) {
      if ((this.tipoComision == 1 || this.tipoComision == 3) && this.tipoPjeComision == 2) {
        this.pjeComision = this.feeAgencia * this.pjeFeeComisionPresupuesto / 100;
        //this.importe = 0;
      }
    },
    'importePresupuesto' : function(newVal, oldVal) {
      if (this.tipoComision == 2 || this.tipoComision == 3) {
        //this.pjeComision = 0;
        this.importe = this.importePresupuesto;
      }
    },
  }    
}
</script>

<style>
  .presupuesto-interno-vendedor-comision .custom-radio {
    margin-bottom: 10px;
  }
  .presupuesto-interno-vendedor-comision .parametros-comision {
    padding-left: 40px;
    padding-right: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .presupuesto-interno-vendedor-comision .parametros-comision .tipo-comision {
    margin-bottom: 20px;
  }
  .presupuesto-interno-vendedor-comision .parametros-comision .parametros-vendedor {
    padding-left: 40px;
  }
  .presupuesto-interno-vendedor-comision .parametros-comision .parametros-vendedor .form-group {
    padding-left: 25px;
  }
  .presupuesto-interno-vendedor-comision hr {
    margin-bottom: 2.5rem;
  }
  .presupuesto-interno-vendedor-comision input[type=number] {
    appearance: textfield;
    -moz-appearance:textfield;
  }
  .presupuesto-interno-vendedor-comision input[type=number]::-webkit-inner-spin-button, 
  .presupuesto-interno-vendedor-comision input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
  }  
</style>
